<template>
    <v-row no-gutters :class="mobile_content ? 'mt-4' : 'mx-4 mt-8'">
        <v-col cols="12">
            <v-dialog
                v-model="payments_syncing"
                hide-overlay
                persistent
                width="300"
            >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                        Loading payments...
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                
                </v-card>
            </v-dialog>
        </v-col>

        <v-col cols="12">
            <v-btn x-small @click="buy_credits" depressed color="green float-right" :class="mobile_content ? 'mr-4' : ''">
                <v-icon x-small left>mdi-star</v-icon>
                Buy Credits
            </v-btn>
        </v-col>

        <v-col cols="12">&nbsp;</v-col>

        <v-col cols="12" class="hidden-sm-and-down">
            <v-data-table
                :headers="payment_headers"
                :items="payments"
                :items-per-page="10"
                class="elevation-1"
                dense
                item-key="appDir"
            >
                <template slot="no-data">
                    No payments made yet
                </template>

                <template v-slot:item.payment_status="{item}">
                    <v-chip small :class="`${item.payment_status}`">
                        {{item.payment_status}}
                    </v-chip>
                </template>

                <template v-slot:item.by="{item}">
                    <span class="text-capitalize">{{item.by}}</span>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
            <v-dialog v-model="payments_syncing" persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Loading payments...
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-list subheader two-line class="mt-2">
                <template v-for="(payment, index) in payments">
                    <v-list-item
                        :key="payment.payment_date"
                    >
                        <v-list-item-content class="pa-0 my-1">
                            <v-list-item-title>
                                <v-chip small>
                                    {{payment.payment_date}}
                                </v-chip>
                                <v-chip small :class="`ml-1 ${payment.payment_status}`">
                                    {{payment.payment_status}}
                                </v-chip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <span class="blue--text">ID</span> - {{payment.payment_id}}<br/>
                                <v-icon small class="blue--text">mdi-currency-usd</v-icon> - {{payment.amount_credited}}/{{payment.amount_purchased}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider
                        v-if="index < payments.length - 1"
                        :key="index"
                    ></v-divider>
                </template>
            </v-list>

            <v-footer app padless>
                <div class="text-center flex-grow-1">
                <v-pagination
                    v-model="page"
                    :length="page_length"
                    :total-visible="total_visible"
                    @input="load_page"
                ></v-pagination>
                </div>
            </v-footer>
        </v-col>
    </v-row>
</template>


<script>
import axios from 'axios';

export default {
  name: "PurchaseHistory",
  data() {
    return {
        mobile_content: false,
        page: 1,
        page_length: 1,
        total_visible: 50,
        payment_headers: [
            { text: 'Date', value: 'payment_date' },
            { text: 'Payment Id', value: 'payment_id' },
            { text: 'Transaction Id', value: 'transaction_id' },
            { text: 'Amount Purchased', value: 'amount_purchased' },
            { text: 'Amount Credited', value: 'amount_credited' },
            { text: 'Promo Code', value: 'promo_code'},
            { text: 'Status', value: 'payment_status'},
            { text: 'Notes', value: 'notes'},
            { text: 'By', value: 'by'}
        ],
        payments: [],
        payments_syncing: false,
    }
  },
  methods: {
      load_page(){
          this._getPayments();
      },
      _getPayments() {
        axios.get(`https://${this.$buyerAPI}/payments`)
        .then(resp => {
            this.payments_syncing = false;
            let payment_list = resp.data.data;
            if (this.mobile_view){
                let start_index = (this.page - 1) * this.total_visible;
                let end_index = start_index + this.total_visible;
                this.payments = payment_list.slice(start_index, end_index);
                this.page_length = Math.round(Math.ceil(payment_list.length/50));
            }else{
                this.payments = payment_list || [];
            }
        })
        .catch(() => {})
      },
      buy_credits: function (){
        window.open(`https://portal.gridmarkets.com/init/buy_credits?email=${this.userLoggedIn.linkedin_email || this.userLoggedIn.email}`);
      },
  },
  computed : {
    userLoggedIn : function() { return this.$store.getters.userLoggedIn}
  },
  created () {
      this.payments_syncing = true;
      this._getPayments();
      if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
        this.mobile_content = true;
      }
  }
}
</script>
<style scoped>
    .v-chip.Completed{
        background: #1976D2 !important;
    }
    .v-chip.Failed{
        background: #FF5252 !important;
    }
</style>